import classNames from 'classnames';
import styles from './quality-metrics.module.scss';
import { useSelector } from 'react-redux';
import { isQualityMetricsEnabled } from 'shared/store/selectors/features.selector';
import { getLang } from 'shared/store/selectors/lang.selector';
import { ScreenTitle } from 'src/components/design-system';
import { NotFound } from 'src/components/common';
import { QualityMetricsProvider } from './quality-metrics-context';
import { QualityMetricsLayout } from './quality-metrics-layout';
import { CaseDetail } from './components/case-detail';
import { Link, Routes, Route } from 'react-router-dom';
import { ROUTES } from 'shared/constants';

function MetricsView() {
  const lang = useSelector(getLang('QUALITY_METRIC'));
  const sidebarLang = useSelector(getLang('SIDEBAR'));

  return (
    <>
      <Link to={ROUTES.HOME} className={styles.breadcrumb}>
        {sidebarLang.HOME}
      </Link>
      <ScreenTitle title={lang.METRICS_HEADER} />
      <QualityMetricsProvider>
        <QualityMetricsLayout />
      </QualityMetricsProvider>
    </>
  );
}

export function QualityMetricsPage() {
  const isEnabled = useSelector(isQualityMetricsEnabled);

  if (!isEnabled) {
    return <NotFound />;
  }

  return (
    <div className={classNames('new-design-system', styles.root)}>
      <Routes>
        <Route path="cases/:id" element={<CaseDetail />} />
        <Route path=":metricId" element={<MetricsView />} />
        <Route index element={<MetricsView />} />
      </Routes>
    </div>
  );
}
